import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { CommonService } from './common.service';
import { map, of, tap } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class TokenResolverService implements Resolve<any> {  
  constructor(
    private commonService: CommonService,
    private userService: AuthService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const queryParamValue = '20'; //route.queryParamMap.get('reportId');
    const email = this.userService.$authState()?.username;
    const configData = this.commonService.$BmpDashboardConfig();
    if (configData != null && queryParamValue != null) {
      const config = configData.find(
        (item) => item.dashboardConfigId == Number(queryParamValue)
      );
      this.commonService.moduleName?.next(config!.displayName);
      return of({
        reportId: config?.reportId,
        workspaceId: config?.workspaceId,
        datasetId: config?.datasetId,
        moduleName: config?.displayName,
        RLSValue: config?.rlsValue,
        isRLSEnable: config?.isRLSEnable
      });
    }
    if (queryParamValue && email) {
      return this.commonService
        .getDashboardAccessDetails(queryParamValue, email)
        .pipe(
          tap((response) => {
            this.commonService.moduleName?.next(response.DisplayName);
          }),
          map((response) => ({
            reportId: response.ReportId,
            workspaceId: response.WorkspaceId,
            datasetId: response.DatasetId,
            moduleName: response.DisplayName,
            RLSValue: response?.rlsValue,
            isRLSEnable: response?.isRLSEnable
          }))
        );
    } else {
      throw new Error('ReportId parameter is missing or null');
    }
  }
}
